// Create an array of all the possible funds from the payload
// and map them to an object which the Dropdown can understand
export const getArrayOfFunds = (Funds) =>
  Funds?.map((fund) => ({
    key: fund.FundTessituraId,
    name: fund.FundName,
    fundDescription: fund.FundDescription,
    fundImage: fund.FundImage,
  }));

// Pick the fund which matches the current chosen Donation ID
export const getChosenFundDetails = (donationFundId, Funds) =>
  getArrayOfFunds(Funds).find((fund) => fund.key === donationFundId);

// Get the amount for the "rounded amount" option
export const getRoundedDonationAmount = (order) => {
  const calcRemainingAmount = 10 - (order.Cart.OrderTotal % 10);
  const roundedAmount = parseFloat(calcRemainingAmount);
  return roundedAmount;
};
